/** Lucide icons (2px stroke) as an inline SVG sprite. Render <IconSprite/> once, then <Icon name="…"/>. */

const PATHS = {
  check: ['M20 6 9 17l-5-5'],
  left: ['m12 19-7-7 7-7', 'M19 12H5'],
  plus: ['M5 12h14', 'M12 5v14'],
  history: ['M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8', 'M3 3v5h5', 'M12 7v5l4 2'],
  mic: ['M12 2a3 3 0 0 0-3 3v7a3 3 0 0 0 6 0V5a3 3 0 0 0-3-3Z', 'M19 10v2a7 7 0 0 1-14 0v-2', 'M12 19v3'],
  send: ['m22 2-7 20-4-9-9-4Z', 'M22 2 11 13'],
  x: ['M18 6 6 18', 'm6 6 12 12'],
  alert: ['M12 8v4', 'M12 16h.01', 'M21.73 18 13.73 4a2 2 0 0 0-3.46 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3Z'],
  lightbulb: [
    'M15 14c.2-1 .7-1.7 1.5-2.5 1-.9 1.5-2.2 1.5-3.5A6 6 0 0 0 6 8c0 1 .2 2.2 1.5 3.5.7.7 1.3 1.5 1.5 2.5',
    'M9 18h6',
    'M10 22h4',
  ],
  instagram: [
    'M7 2h10a5 5 0 0 1 5 5v10a5 5 0 0 1-5 5H7a5 5 0 0 1-5-5V7a5 5 0 0 1 5-5Z',
    'M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37Z',
    'M17.5 6.5h.01',
  ],
  logout: ['M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4', 'm16 17 5-5-5-5', 'M21 12H9'],
} as const;

export type IconName = keyof typeof PATHS;

export function IconSprite() {
  return (
    <svg width="0" height="0" style={{ position: 'absolute' }} aria-hidden="true">
      {(Object.keys(PATHS) as IconName[]).map((n) => (
        <symbol key={n} id={`i-${n}`} viewBox="0 0 24 24">
          {PATHS[n].map((d) => (
            <path key={d} d={d} />
          ))}
        </symbol>
      ))}
    </svg>
  );
}

export function Icon({ name }: { name: IconName }) {
  return (
    <svg className="ic" aria-hidden="true" focusable="false">
      <use href={`#i-${name}`} />
    </svg>
  );
}

/** The three-slab beatsquares mark. */
export function Mark() {
  return (
    <svg className="mark" viewBox="0 0 75.9 77.38" aria-hidden="true" focusable="false">
      <path
        fill="currentColor"
        d="M14.8,56.48l9.44-16.35c.51-.89.51-1.98,0-2.87l-9.44-16.35c-1.11-1.92-3.87-1.92-4.98,0L.38,37.26c-.51.89-.51,1.98,0,2.87l9.44,16.35c1.11,1.92,3.87,1.92,4.98,0Z"
      />
      <path
        fill="currentColor"
        d="M75.55,29.96L58.98,1.26c-.45-.78-1.28-1.26-2.18-1.26H17.94c-1.94,0-3.15,2.1-2.18,3.77l16.57,28.71c.45.78,1.28,1.26,2.18,1.26h38.86c1.94,0,3.15-2.1,2.18-3.77Z"
      />
      <path
        fill="currentColor"
        d="M32.34,44.89l-16.58,28.72c-.97,1.68.24,3.77,2.18,3.77h38.86c.9,0,1.73-.48,2.18-1.26l16.58-28.72c.97-1.68-.24-3.77-2.18-3.77h-38.86c-.9,0-1.73.48-2.18,1.26Z"
      />
    </svg>
  );
}
